import React from 'react';

const Send = props => {
  return (
    <svg
      width={props.height ?? '40'}
      height={props.height ?? '40'}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.8791 2.1901C37.8679 2.17833 37.8566 2.16669 37.8451 2.15519C37.5521 1.86215 37.1771 1.70104 36.7939 1.67188C36.6897 1.66388 36.5844 1.66566 36.4795 1.67752C36.3442 1.69272 36.2103 1.72447 36.0813 1.77277L2.78272 13.4273C2.13772 13.653 1.69588 14.2496 1.66802 14.9324C1.64016 15.6152 2.03194 16.2459 2.6564 16.5234L17.0706 22.9297L23.4769 37.3439C23.7545 37.9684 24.3851 38.3602 25.0679 38.3323C25.7507 38.3045 26.3473 37.8626 26.5731 37.2176L38.2277 3.91874C38.2749 3.79236 38.3064 3.6614 38.3219 3.52893C38.379 3.0445 38.221 2.55253 37.8791 2.1901ZM30.3238 7.31949L7.85176 15.1847L17.9642 19.6791L30.3238 7.31949ZM20.3212 22.0361L32.6808 9.67651L24.8156 32.1486L20.3212 22.0361Z"
        fill={props.color ?? '#fff'}
      />
    </svg>
  );
};

export default Send;
